import { joinRoom, send } from '~/actions/rooms';

export const list = (dispatch, apiClient) => {
  dispatch({ type: 'DASHBOARD_PENDING' });
  return apiClient
    .call({
      endpoint: 'dashboard/list'
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'DASHBOARD_LIST', list: res.data });
    })
    .catch(e => {
      dispatch({ type: 'DASHBOARD_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get dashboard list",
        snackType: 'warning'
      });
      throw e;
    });
};

export const remove = (dispatch, apiClient, dashboardId) => {
  return apiClient
    .call({
      endpoint: 'dashboard/removeById',
      data: { dashboardId }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      send(dispatch, apiClient, dashboardId, 'dashboardCmd', {
        action: 'reload'
      });
      list(dispatch, apiClient);
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't remove dashboard",
        snackType: 'warning'
      });
      throw e;
    });
};

export const handleDashboardCmd = (dispatch, cmdId) => {
  dispatch({ type: 'DASHBOARD_HANDLE_CMD', cmdId });
};

export const setInfo = (dispatch, apiClient, dashboardId, info) => {
  return apiClient
    .call({
      endpoint: 'dashboard/setInfo',
      data: { dashboardId, info }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      send(dispatch, apiClient, dashboardId, 'dashboardCmd', {
        action: 'reload'
      });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: 'Dashboard saved',
        snackType: 'accept'
      });
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't set dashboard data",
        snackType: 'warning'
      });
      throw e;
    });
};

export const init = (dispatch, apiClient, dashboardId, info) => {
  return apiClient
    .call({
      endpoint: 'dashboard/initDevice',
      data: { dashboardId, info }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({
        type: 'COOKIE_SET',
        key: 'dashboardId',
        value: res.data.dashboardId
      });
      joinRoom(dispatch, apiClient, res.data.dashboardId);
      list(dispatch, apiClient);
      dispatch({ type: 'DASHBOARD_INIT', device: res.data });
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't init dashboard",
        snackType: 'warning'
      });
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/dashboards.js